(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  const syncLanguageReturn = () => {
    document.querySelectorAll('.mb-language-selector input[name="return_to"]').forEach((field) => {
      field.value = window.location.pathname + window.location.search + window.location.hash;
    });
  };
  const bindLanguageMenus = (root = document) => {
    syncLanguageReturn();
    root.querySelectorAll('[data-mb-language-menu]').forEach((menu) => {
      if (menu.dataset.mbLanguageBound) return;
      menu.dataset.mbLanguageBound = 'true';
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !menu.open) return;
        event.preventDefault();
        menu.removeAttribute('open');
        menu.querySelector('summary')?.focus({ preventScroll: true });
      });
      menu.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.removeAttribute('open');
      });
      // Shopify supplies return_to; refresh its query and fragment at submission.
      menu.closest('form')?.addEventListener('submit', (event) => {
        syncLanguageReturn();
        if (event.submitter?.getAttribute('aria-current') !== 'true') return;
        event.preventDefault();
        menu.removeAttribute('open');
        menu.querySelector('summary')?.focus({ preventScroll: true });
      });
    });
  };
  window.addEventListener('shopify:section:load', (event) => bindLanguageMenus(event.target));
  window.addEventListener('pointerdown', (event) => {
    document.querySelectorAll('[data-mb-language-menu][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  ready(() => {
    document.querySelector('.mb-form-success, .mb-form-errors')?.focus({ preventScroll: true });

    const header = document.querySelector('[data-mb-header]');
    const syncHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 18);
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });

    document.querySelectorAll('[data-mb-menu]').forEach((menu) => {
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => menu.removeAttribute('open')));
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          menu.removeAttribute('open');
          menu.querySelector('summary')?.focus();
        }
      });
    });

    bindLanguageMenus();

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = document.querySelectorAll('[data-mb-reveal]');
    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        }),
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
      );
      revealItems.forEach((item) => { item.classList.add('mb-reveal-ready'); observer.observe(item); });
    }

    document.querySelectorAll('[data-mb-filter]').forEach((filter) => {
      const buttons = filter.querySelectorAll('[data-filter-value]');
      const cards = filter.querySelectorAll('[data-category]');
      const activeCategory = filter.dataset.mbCollection;
      const isAllStyles = filter.dataset.mbAllStyles === 'true';
      const requestedFilter = new URLSearchParams(window.location.search).get('category');
      const initialFilter = isAllStyles
        ? ([...buttons].some((button) => button.dataset.filterValue === requestedFilter) ? requestedFilter : 'all')
        : activeCategory;
      buttons.forEach((button) => {
        const selected = button.dataset.filterValue === initialFilter;
        button.setAttribute('aria-current', String(selected));
      });
      // Only filter in-place on the complete all-styles page. Category pages
      // retain normal links so navigation never filters an incomplete subset.
      if (!isAllStyles) return;
      const applyFilter = (value) => {
        buttons.forEach((item) => item.setAttribute('aria-current', String(item.dataset.filterValue === value)));
        cards.forEach((card) => {
          card.hidden = value !== 'all' && card.dataset.category !== value;
        });
        const empty = filter.querySelector('[data-mb-empty]');
        if (empty) {
          empty.hidden = [...cards].some((card) => !card.hidden);
          const inquiry = empty.querySelector('a.mb-button');
          if (inquiry) inquiry.href = filter.dataset.mbInquiryUrl + '?category=' + encodeURIComponent(value);
        }
      };
      buttons.forEach((button) => button.addEventListener('click', (event) => {
        event.preventDefault();
        applyFilter(button.dataset.filterValue);
      }));
      applyFilter(initialFilter);
    });

    document.querySelectorAll('.mb-project-form').forEach((form) => {
      const messages = form.querySelector('[data-mb-form-messages]')?.dataset || {};
      const params = new URLSearchParams(window.location.search);
      const requestedCategory = (params.get('category') || '').trim();
      const categoryAliases = {
        men: "Men's underwear", 'mens-underwear': "Men's underwear", 'men-s-underwear': "Men's underwear",
        sleep: 'Loungewear', sleepwear: 'Loungewear',
        intimates: "Women's intimates", underwear: "Women's intimates", bras: "Women's intimates",
        'womens-intimates': "Women's intimates", 'women-s-intimates': "Women's intimates",
        't-shirt': 'T-shirts', tshirts: 'T-shirts',
        active: 'Other', activewear: 'Other', swim: 'Other', swimwear: 'Other', kids: 'Other',
      };
      const categoryKey = requestedCategory.toLowerCase();
      const category = Object.prototype.hasOwnProperty.call(categoryAliases, categoryKey)
        ? categoryAliases[categoryKey]
        : requestedCategory;
      if (category) {
        const option = [...form.querySelectorAll('[name="contact[category]"]')].find(field => field.value.toLowerCase() === category.toLowerCase());
        if (option) option.checked = true;
      }
      const source = {
        style: params.get('style') || '',
        style_title: params.get('style_title') || '',
        style_url: params.get('style_url') || '',
        source_category: requestedCategory,
      };
      Object.entries(source).forEach(([name, value]) => {
        const field = form.querySelector(`[name="contact[${name}]"]`);
        if (field) field.value = value;
      });
      const interest = form.querySelector('[data-mb-style-interest]');
      if (interest && source.style_title) {
        interest.textContent = (messages.interest || '[title]').replace('[title]', () => source.style_title);
        interest.hidden = false;
      }

      const steps = [...form.querySelectorAll('[data-mb-step]')];
      const progress = form.querySelector('[data-mb-progress]');
      const referenceStep = form.querySelector('[data-mb-reference-step]');
      const referenceFields = referenceStep ? [...referenceStep.querySelectorAll('input, textarea')] : [];
      if (steps.length < 2) return;
      form.classList.add('mb-form--enhanced');
      let active = 0;

      const showStep = (index, moveFocus = true) => {
        active = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach((step, stepIndex) => {
          step.hidden = stepIndex !== active;
          step.setAttribute('aria-hidden', String(stepIndex !== active));
        });
        if (progress) {
          progress.textContent = (messages.progress || '[current] / [total]').replace('[current]', active + 1).replace('[total]', steps.length);
          progress.style.setProperty('--mb-progress', `${((active + 1) / steps.length) * 100}%`);
        }
        if (moveFocus) {
          const focusTarget = steps[active].querySelector('legend') || steps[active];
          focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
          steps[active].scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }
      };

      const validStep = () => {
        const fields = [...steps[active].querySelectorAll('input, select, textarea')];
        const invalid = fields.find((field) => !field.checkValidity());
        if (invalid) invalid.reportValidity();
        return !invalid;
      };

      const hasReference = () => referenceFields.some((field) => field.value.trim() !== '');
      const setReferenceStatus = (value) => {
        const field = form.querySelector('[data-mb-reference-status]');
        if (field) field.value = value;
      };
      referenceFields.forEach((field) => field.addEventListener('input', () => {
        setReferenceStatus(hasReference() ? 'Provided' : 'Not provided');
      }));

      const nextStep = () => {
        if (validStep()) {
          if (steps[active] === referenceStep) setReferenceStatus(hasReference() ? 'Provided' : 'Not provided');
          showStep(active + 1);
        }
      };
      form.querySelectorAll('[data-mb-next]').forEach((button) => button.addEventListener('click', nextStep));
      form.addEventListener('keydown', (event) => {
        // Intercept implicit submission before native validation reaches hidden
        // required fields. Textareas, buttons and the final step keep their defaults.
        if (event.key !== 'Enter' || event.isComposing || active === steps.length - 1 || event.target.tagName !== 'INPUT') return;
        if (['button', 'submit', 'reset'].includes(event.target.type)) return;
        event.preventDefault();
        nextStep();
      });
      form.querySelectorAll('[data-mb-skip]').forEach((button) => button.addEventListener('click', () => {
        referenceFields.forEach((field) => {
          field.value = '';
        });
        setReferenceStatus('Skipped');
        showStep(active + 1);
      }));
      form.querySelectorAll('[data-mb-back]').forEach((button) => button.addEventListener('click', () => showStep(active - 1)));
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          const firstInvalid = form.querySelector(':invalid');
          const invalidStep = steps.findIndex((step) => step.contains(firstInvalid));
          if (invalidStep >= 0) showStep(invalidStep);
          firstInvalid?.reportValidity();
          return;
        }
        const submit = form.querySelector('[type="submit"]');
        if (submit) {
          submit.disabled = true;
          submit.dataset.originalLabel = submit.textContent;
          submit.textContent = messages.sending || submit.textContent;
        }
      });
      showStep(0, false);
    });
  });
})();
